/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Update_ButtonInputs */

const en_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Issue`)
};

const fr_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour l'incident`)
};

const de_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update-Problem`)
};

const it_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema di aggiornamento`)
};

const ru_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновление информации по проблеме`)
};

const es_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de actualización`)
};

const zh_cn2_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新问题`)
};

const ja_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップデートの問題`)
};

const hi_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट समस्या`)
};

const pt_pt2_manual_qc_update_button = /** @type {(inputs: Manual_Qc_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema de atualização`)
};

/**
* | output |
* | --- |
* | "Update Issue" |
*
* @param {Manual_Qc_Update_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_update_button = /** @type {((inputs?: Manual_Qc_Update_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Update_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_update_button(inputs)
	if (locale === "de") return de_manual_qc_update_button(inputs)
	if (locale === "it") return it_manual_qc_update_button(inputs)
	if (locale === "ru") return ru_manual_qc_update_button(inputs)
	if (locale === "es") return es_manual_qc_update_button(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_update_button(inputs)
	if (locale === "ja") return ja_manual_qc_update_button(inputs)
	if (locale === "hi") return hi_manual_qc_update_button(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_update_button(inputs)
	return en_manual_qc_update_button(inputs)
});